var map = {
	"./backgrounds/account.svg": "eba4",
	"./backgrounds/lightning.svg": "d728",
	"./backgrounds/lightning2.svg": "b812",
	"./backgrounds/signup_mask-bottom.svg": "4964",
	"./backgrounds/signup_mask-top.svg": "a930",
	"./backgrounds/signup_mask.svg": "4886",
	"./button-detail.svg": "af1f",
	"./clock.svg": "e0f8",
	"./close-icon.svg": "7ddb",
	"./home-background.svg": "c7f2",
	"./junior.svg": "41ff",
	"./kim/kim-happy.svg": "d3e9",
	"./kim/kim-neutral.svg": "6426",
	"./kim/kim-playful.svg": "ad91",
	"./kim/kim-sad.svg": "6d82",
	"./padlock.svg": "e426",
	"./player-ruffle.svg": "be57",
	"./playkids-logo-black.svg": "9515",
	"./playkids-logo.svg": "ee43",
	"./tv.svg": "7834",
	"./wifi.svg": "ff6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";